//
//
//
//
//
//

import index from './index';
export default {
  name: 'Income',
  components: {
    index: index
  }
};